'use strict';

var PinchZoomLibrary = require('pinch-zoom-js/src/pinch-zoom').default;

// eslint-disable-next-line valid-jsdoc
/**
 * Display the returned message.
 * @param {Object} slider- glide slider
 */
function disableZoom(slider) {
    if (slider.length) {
        for (let i = 0; i < slider.length; i++) {
            if (slider[i] && !slider[i].disabled) {
                slider[i].disable();
            }
        }
    }
}

/**
 * Display the returned message.
 * @param {Object} slider - glide slider
 */
function enableZoom(slider) {
    if (slider.length) {
        for (let i = 0; i < slider.length; i++) {
            if (slider[i] && slider[i].disabled) {
                slider[i].enable();
            }
        }
    }
}

/**
 * Display the returned message.
 * @param {Object} pzpdimg -image element
 */
function initPinchZoom(pzpdimg) {
    var imgHeight = pzpdimg.offsetHeight;
    var imageWidth = pzpdimg.offsetWidth;

    var pz = new PinchZoomLibrary(pzpdimg, {
        draggableUnzoomed: false,
        minZoom: 0.9,
        zoomOutFactor: 0,
        onDragStart: function (o, e) {
            e.preventDefault();
        },
        onZoomUpdate: function (obj) {
            pz.currentScale = obj.zoomFactor;
            if (pz.currentScale > 1) {
                // eslint-disable-next-line no-undef
                disableZoom(pdpGlide);
            } else if (pz.currentScale === 0.9) {
                // eslint-disable-next-line no-undef
                enableZoom(pdpGlide);
                obj.options.zoomOutFactor = 1;
            } else {
                // eslint-disable-next-line no-undef
                enableZoom(pdpGlide);
                obj.options.zoomOutFactor = 1;
            }
            obj.update();
        }
    });
    if (pzpdimg.parentElement.offsetHeight === 0 && imgHeight !== 0) {
        pzpdimg.closest('.slide-link').style.height = imgHeight + 'px';
        pzpdimg.parentElement.style.height = imgHeight + 'px';
    }
    if (pzpdimg.parentElement.offsetWidth === 0 && imageWidth !== 0) {
        pzpdimg.closest('.slide-link').style.width = '100%';
        pzpdimg.parentElement.style.width = imageWidth + 'px';
    }
    pz.enable();
}

module.exports = {
    pinchZoomPdp: function (glideSlider, isCampchef, isActionSports) {
        window.pdpGlide = glideSlider;
        var pdImage = document.querySelectorAll('.pinch-zoom');
        if (isCampchef) {
            pdImage.forEach(element => {
                element.onload = function () {
                    initPinchZoom(element);
                };
            });
        } else if (isActionSports) {
            pdImage.forEach(element => {
                if (element.complete) {
                    element.closest('.slide-link').style.height = element.closest('.slide-link').offsetHeight + 'px';
                    initPinchZoom(element);
                } else {
                    element.onload = function () {
                        element.closest('.slide-link').style.height = element.closest('.slide-link').offsetHeight + 'px';
                        initPinchZoom(element);
                    };
                }
            });
        } else {
            pdImage.forEach(element => {
                if (element.complete) {
                    initPinchZoom(element);
                } else {
                    element.onload = function () {
                        initPinchZoom(element);
                    };
                }
            });
        }
    }
};

